'use client';

import { useTranslation } from 'react-i18next';

import { useRouter, useSearchParams } from 'src/routes/hooks';

import { getCountryData } from 'src/assets/data';

import { toast } from 'src/components/snackbar';
import { useSettingsContext } from 'src/components/settings';

import { getLanguageData } from './all-langs';
import { fallbackLang, changeLangMessages as messages } from './locales-config';

// ----------------------------------------------------------------------

export function useTranslate(ns) {
  const router = useRouter();

  const settings = useSettingsContext();

  const searchParams = useSearchParams();

  const { t, i18n } = useTranslation(ns);

  const currentLang = getLanguageData(i18n.language, fallbackLang);
  const countryData = getCountryData(searchParams.get('country') || settings.state?.countryName);

  if (countryData?.code) {
    currentLang.countryCode = countryData?.code;
    currentLang.countryName = countryData?.name;
    currentLang.numberFormat = countryData?.numberFormat;
  }

  const onChangeLang = (newLang) => {
    try {
      const langChangePromise = i18n.changeLanguage(newLang);
      const currentMessages = messages[newLang] || messages.en;

      toast.promise(langChangePromise, {
        loading: currentMessages.loading,
        success: () => currentMessages.success,
        error: currentMessages.error,
      });

      router.refresh();
    } catch (error) {
      console.error(error);
    }
  };

  return { t, i18n, currentLang, onChangeLang };
}
